import gql from 'graphql-tag';

import { CatchFragments } from './fragments/CatchType';
import { ImageFragments } from './fragments/ImageType';
import { PostFragments } from './fragments/PostType';
import { SpeciesFragments } from './fragments/SpeciesTypes';
import { UserFragments } from './fragments/UserType';

export const getOtherSuggestedCatches = gql`
  query GetOtherSuggestedCatches($externalId: String!) {
    entry: catch(externalId: $externalId) {
      ...CatchId
      recommendedCatches(first: 10, filters: { withPhotos: true }) {
        edges {
          node {
            ...CatchId
            post {
              ...PostId
              images(first: 1, croppingStrategy: SMART, height: 400, width: 400) {
                edges {
                  node {
                    ...ImageFields
                  }
                }
                totalCount
              }
            }
            user {
              ...UserId
              ...UserAvatar
              nickname
              isPremium
            }
          }
        }
      }
    }
  }
  ${CatchFragments.id}
  ${ImageFragments.imageFields}
  ${PostFragments.id}
  ${UserFragments.avatar}
  ${UserFragments.id}
`;

export const getUserCatchesExcludingCatch = gql`
  query GetUserCatchesExcludingCatch($externalId: String!, $excludeId: String!) {
    entry: user(externalId: $externalId) {
      catches(
        first: 6
        filters: { excludingCatch: $excludeId, withPhotos: true, orderByRecent: true }
      ) {
        edges {
          node {
            ...CatchMetadata
            user {
              ...UserId
              ...UserAvatar
              nickname
              isPremium
            }
            post {
              ...PostId
              images(first: 1, croppingStrategy: SMART, height: 400, width: 400) {
                edges {
                  node {
                    ...ImageFields
                  }
                }
                totalCount
              }
            }
          }
        }
      }
    }
  }
  ${CatchFragments.metadata}
  ${UserFragments.avatar}
  ${UserFragments.id}
  ${PostFragments.id}
  ${ImageFragments.imageFields}
`;

export const getPostIdByCatchId = gql`
  query GetPostIdByCatchId($externalId: String!) {
    entry: catch(externalId: $externalId) {
      ...CatchId
      post {
        ...PostId
        externalId
      }
    }
  }
  ${CatchFragments.id}
  ${PostFragments.id}
`;

export const getCatchesInMapBoundingBox = gql`
  query GetCatchesInMapBoundingBox(
    $boundingBox: BoundingBoxInputObject
    $first: Int
    $after: String
    $caughtInMonths: [MonthEnum!]
    $speciesIds: [String!]
  ) {
    mapArea(boundingBox: $boundingBox) {
      catches(
        first: $first
        after: $after
        caughtInMonths: $caughtInMonths
        speciesIds: $speciesIds
      ) {
        totalCount
        pageInfo {
          startCursor
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...CatchId
            createdAt
            caughtAtGmt
            post {
              ...PostId
              catch {
                ...CatchId
                ...CatchFishingWaterName
                ...CatchSpeciesName
              }
              comments {
                totalCount
              }
              createdAt
              displayProductUnits {
                totalCount
              }
              ...PostProductUnits
              ...PostVideoFields
              images(first: 1, croppingStrategy: SMART, height: 260, width: 333) {
                totalCount
                edges {
                  node {
                    ...ImageFields
                  }
                }
              }
              likedByCurrentUser
              likesCount
              text {
                text
              }
              user {
                ...UserId
                ...UserAvatar
                nickname
              }
            }
            species {
              ...SpeciesId
              displayName
            }
          }
        }
      }
    }
  }
  ${CatchFragments.id}
  ${CatchFragments.fishingWaterName}
  ${CatchFragments.speciesName}
  ${PostFragments.id}
  ${SpeciesFragments.id}
  ${PostFragments.productUnits}
  ${PostFragments.videoFields}
  ${ImageFragments.imageFields}
  ${UserFragments.avatar}
  ${UserFragments.id}
`;

export const getCatchCountInMapBoundingBox = gql`
  query GetCatchCountInMapBoundingBox($boundingBox: BoundingBoxInputObject) {
    mapArea(boundingBox: $boundingBox) {
      catches {
        totalCount
      }
    }
  }
`;

export const getSingleCatchForViewer = gql`
  query GetSingleCatchForViewer($externalId: String!) {
    catch(externalId: $externalId) {
      ...CatchId
      caughtAtGmt
      species {
        ...SpeciesId
        displayName
      }
      createdAt
      post {
        ...PostId
        displayProductUnits {
          totalCount
        }
        catch {
          ...CatchId
          ...CatchFishingWaterName
          ...CatchSpeciesName
        }
        comments {
          totalCount
        }
        createdAt
        ...PostProductUnits
        ...PostVideoFields
        images(first: 1, croppingStrategy: SMART, height: 400, width: 400) {
          totalCount
          edges {
            node {
              ...ImageFields
            }
          }
        }
        likedByCurrentUser
        likesCount
        text {
          text
        }
        user {
          ...UserAvatar
          ...UserId
          nickname
        }
      }
    }
  }
  ${CatchFragments.id}
  ${SpeciesFragments.id}
  ${PostFragments.id}
  ${CatchFragments.fishingWaterName}
  ${CatchFragments.speciesName}
  ${PostFragments.productUnits}
  ${PostFragments.videoFields}
  ${ImageFragments.imageFields}
  ${UserFragments.avatar}
  ${UserFragments.id}
`;
